export default {
	"order.transferOrder": "轉單",
	"order.NoRefund": "無退款",
	"order.Refunding": "退款中",
	"order.RefundSuccessfully": "退款成功",
	"order.PendingPayment": "待付款",
	"order.toBeDelivered": "待發貨",
	"order.PartiallyShipped": "部分發貨",
	"order.Shipped": "已發貨",
	"order.TransactionComplete": "交易完成",
	"order.TradingClosed": "交易關閉",
	"order.PaidWithoutAddress": "已支付無地址",
	"order.NoDeliveryRequired": "無需配送",
	"order.ExpressDelivery": "快遞配送",
	"order.OnlyRefund": "僅退款",
	"order.refundReturn": "退款退貨",
	"order.pendingReview": "待審核",
	"order.passed": "已通過",
	"order.rejected": "已拒絕",
	"order.Revoked": "已撤銷",
	"order.creationTime": "創建時間",
	"order.passingTime": "通過時間",
	"order.rejectionTime": "拒絕時間",
	"order.CancellationTime": "撤銷時間",
	"order.call": "叫叫",
	"order.calledMath": "叫叫數學",
	"order.calledLiteracy": "叫叫識字",
	"order.DownloadTheCallingLiteracyAPP": "下載【叫叫識字】APP",
	"order.clickToDownload": "點擊下載",
	"order.OrScanTheCodeToDownloadAfterRegisteringAndLoggingInYouCanRedeemAndViewTheLiterateContent": "或者掃碼下載，註冊登錄後可兌換和查看識字內容"
}